import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";

import matchSorter from "match-sorter";

import * as modalActions from "../../actions/modalActions";
import * as contractActions from "../../actions/contractActions";
import * as customerActions from "../../actions/customerActions";
import * as userActions from "../../actions/userActions";
import * as contractTierActions from "../../actions/contractTierActions";

import HeaderWrapper from "../common/HeaderWrapper";
import ContractList from "../contract/ContractList";
import ContractForm from "../contract/ContractForm";
import Modal from "../common/Modal";
import ConfirmModal from "../common/ConfirmModal";

const CustomerContractsPage = ({
  match,
  users,
  customer,
  history,
  contractsByCustomer,
  contract,
  codes,
  saving,
  isMobile,
  actions,
  contractToDelete,
  auth,
  contractTiers
}) => {
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [adding, setAdding] = useState(false);
  const [localCustomerId, setLocalCustomerId] = useState(null);

  useEffect(() => {
    if (!contractTiers.length) actions.loadContractTiers();
  }, [actions, contractTiers]);

  useEffect(() => {
    if (!loading && match.params.id && localCustomerId !== match.params.id) {
      const fetchData = async () => {
        await actions.loadContractsByCustomerId(match.params.id);
        setLoading(false);
      };

      setLocalCustomerId(match.params.id);
      fetchData();
      setLoading(true);
    }

    if (!users.length && !loading) actions.loadUsers();
  }, [
    actions,
    loading,
    setLocalCustomerId,
    match.params.id,
    users.length,
    contractsByCustomer,
    localCustomerId
  ]);

  const onClickAdd = () => {
    setAdding(true);
    actions.showModalSuccess("contractDetailsModal");
  };

  const onClickFullViewProject = (id) => {
    history.push(`/app/contracts/${id}`);
  };

  const onClickView = (item) => {
    setAdding(false);
    actions.getContract(item, true);
  };

  const handleDelete = () => {
    actions.deleteContract(contractToDelete);
  };

  const handleAdd = (item) => {
    actions.createContract(item, false);
  };

  const handleSave = (item) => {
    actions.updateContract(item, false);
  };

  const filter = (e) => setSearch(e.target.value);

  const contractForm = (
    <ContractForm
      contract={contract || []}
      customer={customer}
      customers={[customer] || []}
      codes={codes}
      disableCustomerSelect
      users={users}
      onAdd={handleAdd}
      onSave={handleSave}
      onCancel={actions.hideModal}
      adding={adding}
      saving={saving}
      editing={auth.maxRole === 4000 || auth.maxRole >= 8000}
      preventEdit={!(auth.maxRole === 4000 || auth.maxRole >= 8000)}
      contractTiers={contractTiers}
    />
  );

  const contracts = matchSorter(contractsByCustomer, search, {
    keys: [
      "number",
      "name",
      "contract_type.label",
      "customer.name",
      "salesperson.full_name",
      "entered_date",
      "contract_status.label"
    ]
  });

  return (
    <div id="contracts">
      <HeaderWrapper
        breadcrumbs={[{ label: "Contracts" }]}
        onClickAdd={
          (auth.maxRole === 4000 || auth.maxRole >= 8000) && onClickAdd
        }
        onFilter={filter}
        isMobile={isMobile}
      />
      <div className="content-wrapper">
        <ContractList
          loading={loading}
          isMobile={isMobile}
          onClickView={onClickView}
          auth={auth}
          contracts={contracts}
          onClickFullView={onClickFullViewProject}
          total={contracts.length}
          pages={Math.ceil(contracts.length / 10)}
          pageSize={10}
        />
      </div>
      <Modal
        id="contractDetailsModal"
        title={adding ? "Add Contract" : contract.name}
        body={contractForm}
        close={actions.hideModal}
      />
      <ConfirmModal
        id="contractDeleteModal"
        title="Delete Contract"
        body="Are you sure you want to delete this contract?"
        close={actions.hideModal}
        confirm={handleDelete}
      />
    </div>
  );
};

CustomerContractsPage.propTypes = {
  actions: PropTypes.object.isRequired,
  customer: PropTypes.object,
  contract: PropTypes.object,
  saving: PropTypes.bool,
  isMobile: PropTypes.bool,
  contractsByCustomer: PropTypes.array,
  codes: PropTypes.array.isRequired,
  contractToDelete: PropTypes.string,
  users: PropTypes.array,
  auth: PropTypes.object,
  history: PropTypes.object,
  match: PropTypes.any,
  contractTiers: PropTypes.array
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    customer: state.reducers.customer,
    contract: state.reducers.contract,
    contractsByCustomer: state.reducers.contractsByCustomer,
    contractToDelete: state.reducers.contractToDelete,
    saving: state.reducers.savingContract,
    users: state.reducers.users,
    codes: state.reducers.codes,
    auth: state.reducers.auth,
    contractTiers: state.reducers.contractTiers
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...modalActions,
        ...contractActions,
        ...customerActions,
        ...userActions,
        ...contractTierActions
      },
      dispatch
    )
  };
}

export default withRouter(
  connect(mapStatesToProps, mapDispatchToProps)(CustomerContractsPage)
);
